/*************************************************/
/* COOKIES                                       */
/*************************************************/

export class Recaptcha {
    constructor() {
        const siteKey = '6LcK4hslAAAAACeL8r4iGvEkjztLJT9lHU4df2H2';
        const recaptchaScriptBase = 'https://www.google.com/recaptcha/api.js';

        this.LoadRecaptcha = function(){
            const tag = document.createElement('script');
            tag.src = recaptchaScriptBase + '?render=' + siteKey;
            const firstScriptTag = document.getElementsByTagName('script')[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        }

        this.RecaptchaIsPresent = function(){
            if (typeof grecaptcha !== 'undefined') {
                return true;
            }
            return false;
        }
        
        this.GetToken = function(action = 'submit',callback){
            grecaptcha.ready(function() {
                grecaptcha.execute(siteKey, {action: action}).then(function(token) {
                    callback(token);
                });
              });
        }

        this.Init = function(){
            if(!this.RecaptchaIsPresent()){
                this.LoadRecaptcha();
            }
        }
    }
}
export default new Recaptcha();